import SettingConfig from '@module/config/setting';
import convertFormData from '@module/utils/convertFormData';

import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { ApiBaseResponse } from '../../type';
import type {
  AddHeartMission,
  FetchAcceptMissionParams,
  FetchAddMissionParams,
  FetchBjMissionListParams,
  FetchBjMissionListResponse,
  FetchCancelMissionParams,
  FetchFailMissionParams,
  FetchMissionInfoParams,
  FetchMissionInfoResponse,
  FetchMissionSponListParams,
  FetchMissionSponListResponse,
  FetchMyMissionListParams,
  FetchMyMissionListResponse,
  FetchPlayMissionListParams,
  FetchPlayMissionListResponse,
  FetchSuccessMissionParams,
} from './type';

export const fetchMyMission = async (params?: FetchMyMissionListParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(params && { body: convertFormData(params) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/my_mission_spon`, fetchOptions);

  const result = await res.json();

  return result as FetchMyMissionListResponse;
};

/**
 * @description bj 전용 미션 특정 미션목록 
 *   특정 미션 조회 하는 방법
 *      bjUserIdx,
        type: 'all',
        missionIdx: idx,  해당 mission idx
 */

export const fetchBjMissionList = async (params?: FetchBjMissionListParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(params && { body: convertFormData(params) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/bj_get_mission`, fetchOptions);

  const result = await res.json();

  return result as FetchBjMissionListResponse;
};

/**
 * @description 미션 후원 목록
 */
export const fetchMissionSponList = async (params?: FetchMissionSponListParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(params && { body: convertFormData(params) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/spon_list`, fetchOptions);

  const result = await res.json();

  return result as FetchMissionSponListResponse;
};

/**
 * @description미션 특정 미션 정보 조회
 */
export const fetchMissionInfo = async (params?: FetchMissionInfoParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(params && { body: convertFormData(params) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/mission_info`, fetchOptions);

  const result = await res.json();

  return result as FetchMissionInfoResponse;
};

/**
 * @description미션 시청자 미션 챌린지 list 
 *   특정 미션 조회 하는 방법
 *   isChannelYN: 'N',
     type: 'all',
     stat: 'all',
     missionIdx: idx,  해당 mission idx
 *  
 */
export const fetchPlayMissionList = async (FetchPlayGetMissionListParams: FetchPlayMissionListParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(FetchPlayGetMissionListParams && { body: convertFormData(FetchPlayGetMissionListParams) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/user_get_mission`, fetchOptions);

  const result = await res.json();

  return result as FetchPlayMissionListResponse;
};

/**
 * @description 미션 추가후원
 */
export const fetchAddHeartMission = async (params: AddHeartMission) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(params && { body: convertFormData(params) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/add_heart`, fetchOptions);
  const result = await res.json();

  return result as ApiBaseResponse;
};

/**
 * @description 미션 등록
 */
export const fetchAddMission = async (params: FetchAddMissionParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(params && { body: convertFormData(params) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/add`, fetchOptions);

  const result = await res.json();

  return result as ApiBaseResponse;
};

/**
 * @description bj가 미션 시작(승인)
 */
export const fetchAcceptMission = async (params: FetchAcceptMissionParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(params && { body: convertFormData(params) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/accept`, fetchOptions);

  const result = await res.json();

  return result as ApiBaseResponse;
};

/**
 * @description 미션 성공
 */
export const fetchSuccessMission = async (params: FetchSuccessMissionParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(params && { body: convertFormData(params) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/success`, fetchOptions);

  const result = await res.json();

  return result as ApiBaseResponse;
};

/**
 * @description 미션 실패
 */
export const fetchFailMission = async (params: FetchFailMissionParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(params && { body: convertFormData(params) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/fail`, fetchOptions);

  const result = await res.json();

  return result as ApiBaseResponse;
};

/**
 * @description 미션 거부 취소
 */

export const fetchCancelMission = async (params: FetchCancelMissionParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(params && { body: convertFormData(params) }),
  };

  const res = await fetchExtended(`${SettingConfig.API_URL}/v1/mission/cancel`, fetchOptions);

  const result = await res.json();

  return result as ApiBaseResponse;
};
